/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import CurrencyInput from "react-currency-input-field";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { Paper } from "@material-ui/core";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { useForm } from "react-hook-form";
import CheckButton from "react-validation/build/button";
import Form from "react-validation/build/form";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import Helper from "../../../Helper";
import { getTrans as t } from "../../../Localization/translations";
import EditContractLoanService from "../../../services/contract/editContractLoanService";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import ButtonLoading from "../../../components/Loder/buttonLoading";
import ContractLoanPaymentDetails from "./Paymentdetails/ViewPaymentDetail/LoanPaymentDetailview";
import AddLoanPaymentSchedules from "./Loan/addLoanPaymentSchedule";
import DeletePaymentSchedulesService from "../../../services/contract/paymentSchedule/deletePaymentSchedulesService";
import EditLoanPaymentSchedules from "./Loan/editLoanPaymentschedule";

function PaymentScheduleview({ id, contracttype }) {
  const [items, setItems] = useState([]);
  const [payment, setpayment] = useState([]);

  const paymentRef = useRef();

  // contract
  const [contract_number, setContract_number] = useState("");
  const [start_date, setStart_date] = useState("");
  const [contract_term, setContract_term] = useState("");
  const [address_id, setAdddressId] = useState();
  const [contract_type, setContract_type] = useState("");
  const [contractID, setContractID] = useState();
  const [end_date, setEnd_date] = useState("");
  const [customer_name, setCustomer_name] = useState("");
  const [paymentstartdate, setPaymentStartDate] = useState("");
  const [loanamount, setLoanAmount] = useState("");
  const [iir, setIir] = useState();
  const [interestcalculationmethod, setInterestCalculationMethod] =
    useState("");
  const [repaymentprocedure, setRepaymentProcedure] = useState("");
  const [timecountingmethod, setTimeCountingMethod] = useState("");
  const [interestpostingfrequency, setInterestpostingFrequency] = useState("");
  const [paymentmethod, setPaymentMethod] = useState("");
  const [deposit_amount, setDeposit_amount] = useState(0);
  const [feesontime, setFeesOneTime] = useState(0);
  const [tax_rate_rent, setTax_Rate_Rent] = useState(0);
  const [tax_rate_fee, setTax_Rate_Fee] = useState(0);
  const [asset_count, setAsset_count] = useState(0);
  const [payment_count, setPayment_count] = useState(0);
  const [successful, setSuccessful] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customer_id, setCustomer_id] = useState("");
  const [selectedValue, setSelectedValue] = useState(null);
  const [paymentrule, setPaymentRule] = useState("");
  const [contractpaymentfrequency, setContractPaymentFrequency] = useState("");
  const [amount, setamount] = useState("");
  const [noofpayments, setNoofpayments] = useState("");
  const [paymentitems, setPaymentItems] = useState([]);
  
  const [attribute, setAttribute] = useState([
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
    { attribute: "" },
  ]);
  const [taxsetup, setTaxSetup] = useState("")

  useEffect(() => {
    axios.get(API + 'contracts/companysetting-taxsetupview', { headers: authHeader() })
      .then((response) => {
        setTaxSetup(response.data.tax_setup)
      })
  }, []);

  const handelDefault = () => {
    let url = API + "contracts/payment-view/" + id.contract_id + "/";
    axios.get(url, { headers: authHeader() }).then((response) => {
      setItems(response.data);
      setamount(response.data ? response.data[0].amount : "");
      setNoofpayments(response.data ? response.data[0].periods : "");
    })

    try {
        const responsepay = axios.get(`${API}contracts/paymentScheduleCalculation/?id=${id.contract_id}`, {
          headers: authHeader(),
        });
        responsepay.then((response) => {{setPaymentItems(response.data.response)} })
      } catch (error) {
        console.error('Error fetching payment data:', error);
      }
  };

  const handlepayment = () => {
    let url = API + "contracts/paymentschedule-view/" + id.contract_id + "/";
    axios
      .get(url, { headers: authHeader() })
      .then((response) => setpayment(response.data.data))
  };

  useEffect(() => {
    handelDefault();
    EditContractLoanService.getContract(id.contract_id).then((response) => {
      setContract_number(response.data.contract_number);
      setStart_date(new Date(response.data.start_date));
      setContract_term(response.data.contract_term);
      setAdddressId(response.data.address);
      setContract_type(response.data.contract_type);
      setContractID(response.data.contractID);
      setPaymentStartDate(new Date(response.data.paymentstartdate));
      setEnd_date(new Date(response.data.end_date));
      setCustomer_name(response.data.customer_name);
      setDeposit_amount(response.data.deposit_amount);
      setPaymentRule(response.data.paymentrule);
      setContractPaymentFrequency(response.data.paymentfrequency);
      setFeesOneTime(response.data.one_time_fee);
      setTax_Rate_Rent(response.data.tax_rate_rent);
      setTax_Rate_Fee(response.data.tax_rate_fee);
      setIir(response.data.iir);
      setTimeCountingMethod(response.data.timecountingmethod);
      setCustomer_id(response.data.party);
      setSelectedValue(response.data.party);
      setLoanAmount(response.data.loanamount);
      setPaymentMethod(response.data.paymentmethod);
      setInterestCalculationMethod(response.data.interestcalculationmethod);
      setInterestpostingFrequency(response.data.interestpostingfrequency);
      setRepaymentProcedure(response.data.repaymentprocedure);
      setPaymentRule(response.data.paymentrule);
      setAsset_count(response.data.asset_count);
      setPayment_count(response.data.payment_count);
      setAttribute([
        { attribute: response.data.contractattribute1 },
        { attribute: response.data.contractattribute2 },
        { attribute: response.data.contractattribute3 },
        { attribute: response.data.contractattribute4 },
        { attribute: response.data.contractattribute5 },
        { attribute: response.data.contractattribute6 },
        { attribute: response.data.contractattribute7 },
        { attribute: response.data.contractattribute8 },
        { attribute: response.data.contractattribute9 },
        { attribute: response.data.contractattribute10 },
        { attribute: response.data.contractattribute11 },
        { attribute: response.data.contractattribute12 },
        { attribute: response.data.contractattribute13 },
        { attribute: response.data.contractattribute14 },
        { attribute: response.data.contractattribute15 },
      ]);

      reset({
        address: response.data.address,
        selectedValue: response.data.party,
        startdate: response.data.start_date,
      });
    })
  }, []);
  const { handleSubmit, reset } = useForm();
  const form = useRef();
  const checkBtn = useRef();

  // 	const calculateOneTimeTaxRateSum = () => {
  //         let sum = 0;
  //         items.forEach(item => {
  //             if (item.payment_type === 'One Time') {
  //                 sum += parseFloat(item.amount || 0);
  //             }
  //         });
  //         return sum;
  //     };
  // 	useEffect(()=>{
  // calculateOneTimeTaxRateSum()
  // 	},[])

  const handleRegister = () => {
    setSuccessful(false);
    setLoading(true);
    form.current.validateAll();
    // const updatedTaxRateFee = calculateOneTimeTaxRateSum()
    if (checkBtn.current.context._errors.length === 0) {
      EditContractLoanService.editContract(
        id.contract_id,
        contract_number,
        contract_term,
        Helper.DatePicker(start_date),
        Helper.DatePicker(end_date),
        Helper.DatePicker(paymentstartdate),
        address_id,
        contract_type,
        loanamount,
        iir,
        interestcalculationmethod,
        repaymentprocedure,
        timecountingmethod,
        paymentmethod,
        // contractpaymentfrequency,
        deposit_amount,
        feesontime,
        tax_rate_rent,
        tax_rate_fee,
        selectedValue,
        attribute,
        contractpaymentfrequency,
        paymentrule
      ).then((response) => {
        if (response.data.success) {
          setSuccessful(true);
          setLoading(false);
          setTimeout(() => {
            handlepayment();
          }, 1000);
          setTimeout(() => {
            handelDefault();
          }, 2000);
          toast.success(`Updated successfully`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else {
          setLoading(false);
          toast.error(`${response.data.error}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setSuccessful(false);
        }
      })
    }
  };

  const [showaddpayment, setShowAddPayment] = useState(false);

  const [paymentscheduleenddate, setPaymentScheduleEnddate] = useState(
    new Date()
  );

  const handleadd = (id) => {
    if (items.length !== 0) {
      let end_date_send = new Date(items[items.length - 1].end_date);
      end_date_send.setDate(end_date_send.getDate() + 1);
      setPaymentScheduleEnddate(end_date_send);
      setShowAddPayment(true);
    } else {
      setPaymentScheduleEnddate(start_date);
      setShowAddPayment(true);
    }
  };
  const [showeditpayment, setShowEditPayment] = useState(false);
  const [paymentid, setPaymentid] = useState("");

  const handleEdit = (payment_id) => {
    setPaymentid(payment_id);
    setShowEditPayment(true);
  };
  const [refreshPaymentDetails, setRefreshPaymentDetails] = useState(false);
  useEffect(() => {
    if (refreshPaymentDetails) {
      setRefreshPaymentDetails(false); // Reset the flag
    }
  }, [refreshPaymentDetails]);
  const handelDelete = (id) => {
    confirmAlert({
      title: "",
      message: "Are you sure you want to delete this PaymentSchedule?.",
      buttons: [
        {
          label: "Yes",
          onClick: () => {
            DeletePaymentSchedulesService.deletePaymentsSchedules(id).then(
              (response) => {
                if (response.data.success) {
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  handelDefault();
                  setRefreshPaymentDetails(true);
                } else {
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                }
              }
            )
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <>
      {
        showaddpayment === false ? (
          showeditpayment === false ? (
            <>
              <div className="row py-2">
                <ToastContainer />
                <div className="col-md-12">
                  <div className=" mb-0">
                    <div className="header pb-0">
                      <div className="d-lg-flex">
                        <div>
                          <h5 className="mb-0">{t("Payment Schedules")}</h5>
                        </div>
                        {/* <div className="ms-auto my-auto mt-lg-0 mt-4">
                          <div className="ms-auto my-auto">
                            <div onClick={() => handleadd(id)}>
                              <button
                                className="add-address add btn btn-primary mb-0"
                                id="add-task"
                              >
                                +&nbsp; {t("New Payment Schedules")}
                              </button>
                            </div>
                          </div>
                        </div> */}
                      </div>
                    </div>
                    <div className="body">
                      <div className="p-0">
                        <MaterialTable
                          ref={paymentRef}
                          style={{
                            padding: "0.5rem 0.5rem",
                            backgroundColor: "var(--bs-table-bg)",
                            borderBottomWidth: "1px",
                            boxShadow:
                              "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                          }}
                          columns={[
                            {
                              title: `${t("Periods")}`,
                              field: "periods",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc">
                                    {t("Periods")}
                                  </div>
                                  <div>{rowData.periods}</div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("Payment Type")}`,
                              field: "payment_type",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Payment Type")}
                                  </div>
                                  <div>
                                    {rowData.payment_type === null
                                      ? "Rent"
                                      : rowData.payment_type}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                              // hidden : contracttype === 'Loan' ? true : false
                            },

                            {
                              title: `${t("Payment Amount")}`,
                              field: "amount",
                              render: (rowData) => (
                                <>
                                  <div
                                    className={`d-xl-none tc d-md-none d-lg-none`}
                                    style={{
                                      textAlign: rowData.isSmallScreen
                                        ? "left"
                                        : "right",
                                      fontSize: "12px",
                                      fontWeight: rowData.isSmallScreen
                                        ? "bold"
                                        : "",
                                    }}
                                  >
                                    {t("Payment Amount")}
                                  </div>
                                  <div
                                    className={`d-none d-xl-block d-lg-block text-right`}
                                    style={{
                                      textAlign: "right",
                                      fontSize: "12px",
                                    }}
                                  >
                                    {Helper.Amount(rowData.amount)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "right",
                              },
                              // cellStyle: {
                              // 	textAlign: "right",
                              // 	fontSize: 12
                              // }
                            },
                            {
                              title: `${t("Start Date")}`,
                              field: "start_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("Start Date")}
                                  </div>
                                  <div>
                                    {rowData.start_date
                                      ? Helper.DateNormal(rowData.start_date)
                                      : "None"}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                            {
                              title: `${t("End Date")}`,
                              field: "end_date",
                              render: (rowData) => (
                                <>
                                  <div className="d-xl-none tc d-md-none d-lg-none">
                                    {t("End Date")}
                                  </div>
                                  <div>
                                    {Helper.DateNormal(rowData.end_date)}
                                  </div>
                                </>
                              ),
                              headerStyle: {
                                verticalAlign: "inherit",
                                fontWeight: "bold",
                                textAlign: "left",
                              },
                              cellStyle: {
                                textAlign: "left",
                                fontSize: 12,
                              },
                            },
                          ]}
                          data={items}
                          // actions={[
                          //   (rowData) => ({
                          //     icon: () =>
                          //     (

                          //       <img
                          //         src={
                          //           process.env.PUBLIC_URL +
                          //           "/static/images/ic-edit.svg"
                          //         }
                          //         alt=""
                          //       />
                          //     ),
                          //     tooltip: "Edit",
                          //     onClick: (event, rowData) => {
                          //       handleEdit(rowData.id);
                          //     },
                          //   }),
                          //   (rowData) => ({
                          //     icon: () =>
                          //     (
                          //       <img
                          //         src={
                          //           process.env.PUBLIC_URL +
                          //           "/static/images/ic-delete.svg"
                          //         }
                          //         alt="Delete"
                          //       />
                          //     ),
                          //     tooltip: "Delete",
                          //     onClick: (event, rowData) => {
                          //       handelDelete(rowData.id);
                          //     },
                          //   }),
                          //   // (rowData)=>({
                          //   // 	icon : rowData.payment_type == 'Rent' ? <span><img
                          //   // 	  src={
                          //   // 		process.env.PUBLIC_URL +
                          //   // 		"/static/images/ic-delete.svg"
                          //   // 	  }
                          //   // 	  alt=""
                          //   // 	/></span>:"",
                          //   // 	// icon : rowData.payment_type === "Rent" ? "":<img
                          //   // 	//   src={
                          //   // 	// 	process.env.PUBLIC_URL +
                          //   // 	// 	"/static/images/ic-delete.svg"
                          //   // 	//   }
                          //   // 	//   alt=""
                          //   // 	// />,
                          //   // 	tooltip: "Delete",
                          //   // 	onClick: (event, rowData) => {
                          //   // 		handelDelete(rowData.id);
                          //   // 	  },

                          //   // }),
                          //   // {
                          //   //   icon: () => (
                          //   // 	<img
                          //   // 	  src={
                          //   // 		process.env.PUBLIC_URL +
                          //   // 		"/static/images/ic-edit.svg"
                          //   // 	  }
                          //   // 	  alt=""
                          //   // 	/>
                          //   //   ),
                          //   //   tooltip: "Edit",
                          //   //   onClick: (event, rowData) => {
                          //   // 	handleEdit(rowData.id);
                          //   //   },
                          //   // },
                          //   // {
                          //   //   icon: () => (
                          //   // 	<img
                          //   // 	  src={
                          //   // 		process.env.PUBLIC_URL +
                          //   // 		"/static/images/ic-delete.svg"
                          //   // 	  }
                          //   // 	  alt=""
                          //   // 	/>
                          //   //   ),
                          //   //   tooltip: "Delete",
                          //   //   onClick: (event, rowData) => {
                          //   // 	handelDelete(rowData.id);
                          //   //   },
                          //   // },
                          // ]}
                          components={{
                            Container: (props) => (
                              <div id="Payment">
                                <Paper {...props} />
                              </div>
                            ),
                          }}
                          options={{
                            headerStyle: {
                              backgroundColor: "white",
                              color: "#245C7F",
                              fontSize: 12,
                            },
                            rowStyle: (rowData, index) => {
                              if (index % 2) {
                                return { backgroundColor: "#fff" };
                              }
                            },
                            sorting: true,
                            search: false,
                            toolbar: false,
                            paging: true,
                            pageSize: 3, // make initial page size
                            emptyRowsWhenPaging: false, // To avoid of having empty rows
                            pageSizeOptions: [3, 15, 20, 50],
                            paginationType: "stepped",
                            showFirstLastPageButtons: false,
                            actionsColumnIndex: -1,
                          }}
                        />
                      </div>

                      {/* <div className="">
                        <div className="accordion-item mt-2 ">
                          <h2
                            className="accordion-header"
                            id="panelsStayOpen-headingTwo"
                          >
                            <button
                              className="accordion-button collapsed"
                              style={{ color: "#008DC1" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#panelsStayOpen-collapseTwo"
                              aria-expanded="false"
                              aria-controls="panelsStayOpen-collapseTwo"
                            >
                              <b>{t("Payment Additional Information")}</b>
                            </button>
                          </h2>
                          <div
                            id="panelsStayOpen-collapseTwo"
                            className="accordion-collapse collapse"
                            aria-labelledby="panelsStayOpen-headingTwo"
                          >
                            <div className="accordion-body">
                              <Form
                                role="form text-left"
                                onSubmit={handleSubmit(handleRegister)}
                                ref={form}
                                action="."
                                method="POST"
                                id="addPartyForm"
                              >
                                {
                                  <>
                                    <div className="row">
                                      <div className="col-xl-6">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label">
                                            {t("Deposit Amount")}{" "}
                                            <Tooltip
                                              content={t(
                                                "DepositAmount_Tooltip"
                                              )}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <CurrencyInput
                                              id="input-example"
                                              name="input-name"
                                              allowDecimals="false"
                                              value={deposit_amount}
                                              onValueChange={(value) =>
                                                setDeposit_amount(value)
                                              }
                                              className="form-control"
                                              disableAbbreviations
                                            />
                                          </div>
                                        </div>
                                      </div> */}
                                      {/* <div className="col-xl-6">
															<div className="form-group row">
																<label className="col-lg-12 col-form-label">{t('Fees (One-Time)')} <Tooltip content={t("Fees-Onetime_Tooltip")}><i className="fa fa-light fa-circle-info"></i></Tooltip></label>
																<div className="col-lg-12">
																	<CurrencyInput
																		id="input-example"
																		name="input-name"
																		allowDecimals="false"
																		value={feesontime}
																		onValueChange={(value) => setFeesOneTime(value)}
																		className="form-control"
																		disableAbbreviations
																	/>
																</div>
															</div>
														</div> */}
                                      {/* <div className="col-xl-6">
                                        <div className="form-group row">
                                          <label className="col-lg-12 col-form-label">
                                            {t("Tax Rate (Fee)")}{" "}
                                            <Tooltip
                                              content={t("TaxRate-Fee_Tooltip")}
                                            >
                                              <i className="fa fa-light fa-circle-info"></i>
                                            </Tooltip>
                                          </label>
                                          <div className="col-lg-12">
                                            <CurrencyInput
                                              id="input-example"
                                              name="input-name"
                                              allowDecimals="false"
                                              disabled={taxsetup === "Tax Rate Table"}
                                              value={tax_rate_fee}
                                              onValueChange={(value) =>
                                                setTax_Rate_Fee(value)
                                              }
                                              className="form-control"
                                              disableAbbreviations
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <button
                                      type="submit"
                                      className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                                    >
                                      {loading === false ? (
                                        t("Update")
                                      ) : (
                                        <ButtonLoading />
                                      )}
                                    </button>
                                    &nbsp;&nbsp;
                                  </>
                                }
                                <CheckButton
                                  style={{ display: "none" }}
                                  ref={checkBtn}
                                />
                              </Form>
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                    <div className="mt-2">
                      <ContractLoanPaymentDetails
                        contractDate={start_date}
                        paymentRule={paymentrule}
                        paymentFrequency={contractpaymentfrequency}
                        noTerms={contract_term}
                        monthlyAmount={amount}
                        payment_count={payment_count}
                        no_of_payments={noofpayments}
                        items={items}
                        contracttype={contracttype}
                        paymentdetails= {paymentitems}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <EditLoanPaymentSchedules
              paymentid={paymentid}
              contract={id.contract_id}
              contractterm={contract_term}
              payment_rule={paymentrule}
              payment_frequency={contractpaymentfrequency}
              contract_date={start_date}
            />
          )
        ) : (
          <AddLoanPaymentSchedules
            date={paymentscheduleenddate}
            contract={id.contract_id}
            contractterm={contract_term}
            payment_rule={paymentrule}
            payment_frequency={contractpaymentfrequency}
            contract_date={Helper.DatePicker(start_date)}
          />
        )
        // )
      }
    </>
  );
}
export default PaymentScheduleview;
